module.exports = __webpack_public_path__ + "img/jgbged.e97de23a.png";